import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    firstName: yup.string().required('First Name is required'),
    lastName: yup.string().required('Last Name is required'),
    email: yup.string().email('Enter a valid email').required('Email is required'),
    password: yup.string().min(8, 'Password should be of minimum 8 characters length').required('Password is required'),
    confirmationPassword: yup
        .string()
        .required('Please confirm your password')
        .oneOf([yup.ref('password')], "Password doesn't match"),
    phoneNumber: yup
        .string()
        .min(10, 'Phone number should contain 10 characters length')
        .required('Phone number is required'),
});
